import { createApp } from "vue";
import App from "./App.vue";
import pinaMakeStore from "./stores/store";
import { i18n } from "./i18n";
import Select2 from "vue3-select2-component";
import "../src/styles/main.scss";
import "floating-vue/dist/style.css";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "../src/assets/fancybox/jquery.fancybox.min.css";

import "../src/styles/components/imageEditorGalleries.scss";

const fancybox = require("./assets/fancybox/jquery.fancybox.min.js");

import "../src/styles/layouts/layoutImageEditor.scss";

import { useWebproductStore } from "@/stores/modules/webproduct";
import { useCustomerStore } from "@/stores/modules/customer";
import { useConfigStore } from "@/stores/modules/config";

import {
  callbackService,
  registerCallback,
  unregisterCallback,
  setSelectorIdCallback
} from "./helpers/callbackService";

import {
  // Directives
  VTooltip,
  Dropdown,
  Tooltip
} from "floating-vue";

const createPrintqApp = appProps => {
  const app = createApp(App, { appProps });
  app.use(pinaMakeStore());
  app.use(i18n);
  i18n.t = i18n.global.t;
  i18n.setLocaleMessage = i18n.global.setLocaleMessage;
  i18n.getLocaleMessage = i18n.global.getLocaleMessage;
  i18n.mergeLocaleMessage = i18n.global.mergeLocaleMessage;
  app.use(VueSweetalert2, { scrollbarPadding: false });
  app.directive("click-outside", {
    bind: function (el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
        var isBlur = true;
        var blurSelectors = binding.value["blurSelectors"];
        var elements = document.querySelectorAll(blurSelectors);
        for (var i = 0; i < elements.length; i++) {
          var trigger = elements[i],
            cursorTarget = event.target;
          if (trigger == cursorTarget) {
            isBlur = false;
          }
          if (trigger.contains(event.target)) {
            isBlur = false;
          }
        }
        if (isBlur) {
          binding.value["callback"](event);
        }
      };
      document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind: function (el) {
      document.body.removeEventListener("click", el.clickOutsideEvent);
    }
  });

  app.component("SelectOption", Select2);

  app.directive("tooltip", VTooltip);
  app.component("VTooltip", Tooltip);
  app.component("VDropdown", Dropdown);

  registerAllComponents(app);

  return app;
};

const registerAllComponents = app => {
  const requireComponent = require.context(
    // Look for files in the current directory
    "./components",
    // Do not look in subdirectories
    true
    // Only include "_base-" prefixed .vue files
    ///_base-[\w-]+\.vue$/
  );

  // For each matching file name...
  requireComponent.keys().forEach(fileName => {
    if (!fileName.endsWith(".vue")) {
      return;
    }

    // Get the component config
    const componentConfig = requireComponent(fileName);
    // Get the PascalCase version of the component name
    const componentName = fileName
      // Remove the "./_" from the beginning
      .replace(/^\.\/_/, "")
      // Remove the file extension from the end
      .replace(/\.\w+$/, "")
      // Split up kebabs
      .split("-")
      // Upper case
      .map(kebab => {
        var fName =
          kebab.lastIndexOf("/") != -1
            ? kebab.substring(kebab.lastIndexOf("/") + 1)
            : kebab;
        return (fName.charAt(0).toUpperCase() + fName.slice(1)).replace(
          "./",
          ""
        );
      })
      // Concatenated
      .join("");

    var newComponenent = componentConfig.default || componentConfig;
    var className =
      "matrix_" +
      (componentName.charAt(0).toLowerCase() + componentName.slice(1));
    newComponenent = {
      ...newComponenent,
      mixins: [
        {
          computed: {
            getClassName() {
              return className;
            },
            getClassNameContainer() {
              return className + "Container";
            },
            getClassNameItem() {
              return className + "Item";
            },
            getContainerType: function () {
              // for containers we might decide to not show the outer div if we might also include elements from other componenets
              if (this.hideContainer) {
                return "appFragment";
              } else {
                return "div";
              }
            },
            shouldRenderConfig: function () {
              const webproductStore = useWebproductStore();
              return webproductStore.getShouldRenderComponent(componentName);
            }
          }
        }
      ]
    };

    // Globally register the component
    app.component("app" + componentName, newComponenent);
  });
};

//app.mount("#app");

class PrintqMatrixApp {
  constructor() {
    this.vueInstance = null;
  }
  init(args) {
    if (args.config && args.config.configLanguage) {
      // do nothing now
    } else if (args.language) {
      setLanguageAttributes(args.language);
    }
    var selector = "#printq_app";
    if (args.selector) {
      selector = args.selector;
    }
    __webpack_nonce__ = "rAnd0m";
    if (args.jsAppRoot) {
      __webpack_public_path__ = args.jsAppRoot;
    }

    var portalComponents = this.registerPortalComponents();
    callbackService.sendInitialCallback(
      callbackService.callbacks.beforeInitCallback,
      {},
      selector.replace("#", "")
    );
    this.vueInstance = createPrintqApp({
      ...args,
      portalComponents,
      selector: selector.replace("#", "")
    });
    const webproductStore = useWebproductStore();
    webproductStore.setVueInstance(this.vueInstance);
    return this.vueInstance.mount(selector);
  }

  setSelectorId(selectorId) {
    setSelectorIdCallback(selectorId);
  }

  on(type, handler) {
    registerCallback(type, handler);
  }
  off(type) {
    unregisterCallback(type);
  }

  getStore() {
    console.log("adjust this for pinia !!!");
    return null;
    //return this.vueInstance._context.config.globalProperties.$store;
  }
  updateCustomer(customer, isLogin) {
    const customerStore = useCustomerStore();
    customerStore.setCustomer(customer);
    customerStore.setIsLogin(isLogin | 0);
  }

  filesConnected() {
    const configStore = useConfigStore();
    configStore.setDisableDeleteUploadAfterConnect(true);
  }
  isValid() {
    const webproductStore = useWebproductStore();
    return webproductStore.getIsValidForm(null);
  }

  registerPortalComponents() {
    var elements = document.getElementsByClassName("printq_portal");
    var portalComponents = [];
    for (var el of elements) {
      if (el.getAttribute("data-portal") && el.getAttribute("id")) {
        var portal = JSON.parse(el.getAttribute("data-portal"));
        var portalId = el.getAttribute("id");
        portalComponents.push({
          id: "#" + portalId,
          type: "app" + portal.component
        });
      }
    }

    return portalComponents;
  }
}

window.PrintqMatrix = PrintqMatrixApp;
